import { AsyncPipe, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, EventEmitter, Component, ChangeDetectionStrategy, Input, Output } from '@angular/core';
import { TuiButton } from '@taiga-ui/core/components/button';
import { TUI_SPIN_ICONS, TUI_SPIN_TEXTS } from '@taiga-ui/core/tokens';
const _c0 = ["*"];
function TuiSpinButton_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 1);
    i0.ɵɵlistener("click", function TuiSpinButton_ng_container_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLeftClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 2);
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 3);
    i0.ɵɵlistener("click", function TuiSpinButton_ng_container_0_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRightClick());
    });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const texts_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("t-hidden", ctx_r1.leftComputedDisabled);
    i0.ɵɵproperty("iconStart", ctx_r1.icons.decrement)("tabIndex", ctx_r1.focusable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r3[0], " ");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("t-hidden", ctx_r1.rightComputedDisabled);
    i0.ɵɵproperty("iconStart", ctx_r1.icons.increment)("tabIndex", ctx_r1.focusable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r3[1], " ");
  }
}
let TuiSpinButton = /*#__PURE__*/(() => {
  class TuiSpinButton {
    constructor() {
      this.icons = inject(TUI_SPIN_ICONS);
      this.spinTexts$ = inject(TUI_SPIN_TEXTS);
      this.focusable = true;
      this.disabled = false;
      this.leftDisabled = false;
      this.rightDisabled = false;
      this.leftClick = new EventEmitter();
      this.rightClick = new EventEmitter();
    }
    onLeftClick() {
      if (!this.leftComputedDisabled) {
        this.leftClick.emit();
      }
    }
    onRightClick() {
      if (!this.rightComputedDisabled) {
        this.rightClick.emit();
      }
    }
    get leftComputedDisabled() {
      return this.disabled || this.leftDisabled;
    }
    get rightComputedDisabled() {
      return this.disabled || this.rightDisabled;
    }
    static {
      this.ɵfac = function TuiSpinButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiSpinButton)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiSpinButton,
        selectors: [["tui-spin-button"]],
        hostBindings: function TuiSpinButton_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown.zoneless.prevent", function TuiSpinButton_mousedown_zoneless_prevent_HostBindingHandler() {
              return 0;
            })("keydown.arrowLeft.prevent", function TuiSpinButton_keydown_arrowLeft_prevent_HostBindingHandler() {
              return ctx.onLeftClick();
            })("keydown.arrowRight.prevent", function TuiSpinButton_keydown_arrowRight_prevent_HostBindingHandler() {
              return ctx.onRightClick();
            });
          }
        },
        inputs: {
          focusable: "focusable",
          disabled: "disabled",
          leftDisabled: "leftDisabled",
          rightDisabled: "rightDisabled"
        },
        outputs: {
          leftClick: "leftClick",
          rightClick: "rightClick"
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], ["appearance", "flat", "automation-id", "tui-spin-button__left", "size", "xs", "tuiIconButton", "", "type", "button", 3, "click", "iconStart", "tabIndex"], [1, "t-content", "t-calendar-title"], ["appearance", "flat", "automation-id", "tui-spin-button__right", "size", "xs", "tuiIconButton", "", "type", "button", 3, "click", "iconStart", "tabIndex"]],
        template: function TuiSpinButton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, TuiSpinButton_ng_container_0_Template, 7, 10, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.spinTexts$));
          }
        },
        dependencies: [AsyncPipe, NgIf, TuiButton],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:space-between;font:var(--tui-font-text-l);text-align:center;font-weight:700}.t-hidden[_ngcontent-%COMP%]{visibility:hidden}.t-content[_ngcontent-%COMP%]{padding:0 .5rem}"],
        changeDetection: 0
      });
    }
  }
  return TuiSpinButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiSpinButton };
